import cookies from 'js-cookie'
import common from './common'
import { REPORT_PARAMS } from '@/config/dataMap'

const vip_version = REPORT_PARAMS.vip_version
const report_version = REPORT_PARAMS.report_version
const main_from = cookies.get('show_from') || 0
const product_id = 13

const abtestKfmt =
  'duba_newvip_ab:6728 version:byte vip_version:int main_from:int product_id:int ab_test:int ab_result:int user_login:byte openid:string vip_type:string act_name:string fun_name:string curver:int'

// 退出送优惠券
const quitCouponKfmt =
  'duba_newvip_quitcoupon:6727 version:byte vip_version:int main_from:int product_id:int is_show:byte is_show_reason:byte is_click:byte coupon_id:int coupon_money:int act_name:string fun_name:string curver:int'

const recallCouponKfmt =
  'duba_newvip_mainpage_coupon:6816 version:byte vip_version:int main_from:int pay_click:int coupon_click:int product_id:int64 show_from:int pagetype:byte'
export default {
  API: {},
  REPORT: {
    reportabTestKfmt (params) {
      const info = {
        version: report_version,
        vip_version,
        main_from,
        product_id,
        ab_test: 0,
        ab_result: 0,
        user_login: 0,
        openid: '',
        vip_type: 0,
        act_name: '',
        fun_name: '',
        curver: 0
      }
      return common.REPORT.client_report_by_kfmt(
        abtestKfmt,
        common.API.replaceObj(info, params)
      )
    },
    reportQuitCoupon (params) {
      const info = {
        version: report_version,
        vip_version,
        main_from,
        product_id,
        is_show: 0,
        is_show_reason: 0,
        is_click: 0,
        coupon_id: 0,
        coupon_money: 0,
        act_name: '',
        fun_name: '',
        curver: 0
      }
      return common.REPORT.client_report_by_kfmt(
        quitCouponKfmt,
        common.API.replaceObj(info, params)
      )
    },
    reportRecallCoupon (params) {
      const info = {
        version: report_version,
        vip_version,
        main_from: 0,
        pay_click: 0,
        coupon_click: 0,
        product_id,
        show_from: cookies.get('show_from') || 0,
        pagetype: 1
      }
      return common.REPORT.client_report_by_kfmt(
        recallCouponKfmt,
        common.API.replaceObj(info, params)
      )
    },
  }
}
